export const FILTER_DIALOG_WRAPPER_PANEL_CLASS = 'mp-filter-dialog-wrapper-parent';
